<template>
    <div class="menu">
        <div v-if="!isnavopen">
            <div class="menu-top" v-if="!sticky">
                <main-menu :menuConfig="menuConfig" :userInitialName="userInitialName" />
                <menu-button :userInitialName="userInitialName" :userPermission="userPermission" />
            </div>
            <sub-menu :activeConfig="menuConfig.activeConfig" :sticky="sticky" />
        </div>

        <div v-else>
            <div class="menu-mobile">
                <main-menu
                    :isnavopen="isnavopen"
                    :menuConfig="menuConfig"
                    :userInitialName="userInitialName"
                />
            </div>
            <div class="menu-button-display">
                <menu-button :userInitialName="userInitialName" :userPermission="userPermission" />
            </div>
        </div>
    </div>
</template>

<script>
import { find } from "lodash";
import Vue from "vue";
import { EventBus } from "src/bus/eventBus";
import MainMenu from "./MainMenu.vue";
import MenuButton from "./MenuButton.vue";
import SubMenu from "./SubMenu.vue";

export default Vue.extend({
    props: ["isnavopen", "menu", "userInitialName", "userPermission"],
    components: {
        MenuButton,
        SubMenu,
        MainMenu,
    },
    data() {
        return {
            sticky: false,
        };
    },
    computed: {
        menuConfig() {
            const activeParentItem = this.findPublicActiveItem(this.menu);
            const activeChild =
                activeParentItem && this.findPublicActiveItem(activeParentItem.children);
            return {
                mainMenu: this.menu,
                activeConfig: {
                    activeParentId: activeParentItem ? activeParentItem.id : null,
                    activeParentTitle: activeParentItem ? activeParentItem.__title : "",
                    activeParentUrl: activeParentItem ? activeParentItem.url : "",
                    activeChildId: activeChild ? activeChild.id : null,
                    subMenu: activeParentItem ? activeParentItem.children : [],
                },
            };
        },
    },
    methods: {
        findPublicActiveItem(menu) {
            return find(
                menu,
                item => item.current || item.current_item_parent || item.current_item_ancestor
            );
        },
    },
    mounted() {
        EventBus.$on("headerIsFixed:updated", _sticky => {
            this.sticky = _sticky;
        });
    },
});
</script>

<style lang="sass" scoped>
.menu
    width: 100%

    .menu-top
        display: flex
        justify-content: space-between
        border-bottom: 1px solid rgba(176,177,166,0.6)

.menu-button-display
    +r(1140)
        display: none
</style>
